import { PropsWithChildren } from 'react';
import { Spinner } from 'react-bootstrap';
import { useDecodeProvider } from '../../../hooks/filters/use-encode-filter-selection';
import { AccessProvider } from '../../access/provider/access.provider';
import { AppErrorBoundaryPageComponent } from '../../error-boundary/app-error-boundary-page.component';
import { MessagePageComponent } from '../../message-page/message-page.component';
import { FilterableComponentProps } from '../interfaces/filterable-component-props.interface';
import { AppFilterProvider } from './filter.provider';

interface FilterDecodeProviderProps
  extends FilterableComponentProps,
    PropsWithChildren {
  moduleId: string;
}
/**
 * Decodes filter selection from URL params and passes to filter selection receptor component.
 */
export const FilterDecodeProvider = ({
  children,
  FilterSelectionReceptorComponent,
  moduleId,
}: FilterDecodeProviderProps) => {
  // filterSelection changes only once. After URL parameter is decoded, initialFilterSelection won't change.
  const initialFilterSelection = useDecodeProvider();

  if (initialFilterSelection) {
    return (
      <AppErrorBoundaryPageComponent>
        <AccessProvider filterSelection={initialFilterSelection}>
          <AppFilterProvider
            moduleId={moduleId}
            filterSelection={initialFilterSelection}
          >
            <FilterSelectionReceptorComponent
              filterSelection={initialFilterSelection}
            >
              {children}
            </FilterSelectionReceptorComponent>
          </AppFilterProvider>
        </AccessProvider>
      </AppErrorBoundaryPageComponent>
    );
  } else {
    return (
      <MessagePageComponent>
        <div>
          <Spinner size="sm" /> Checking filters... Please, wait.
        </div>
      </MessagePageComponent>
    );
  }
};
